import adminHttp from './adminHttp';

/**
 * GET /admin/instances
 *
 * The caller's `managedInstances` INTERSECTED with the Clerk instances this
 * deployment holds a secret for. That intersection is the whole point: it is the
 * only list from which every entry is both permitted and writable, so a brand
 * control populated from it can never offer something the write path rejects.
 *
 * Returns `{ instances: [{ clerkInstance, brands: string[], isOwn: boolean }] }`.
 */
export const fetchInstances = async () => {
  const { data } = await adminHttp.get('/admin/instances');
  return data;
};
